class Navigation {
  nav = []
  constructor($route) {
    if (!$route) {
      throw new Error('Route is required to build navigation')
    }

    this.$route = $route
    this.nav = [
      // Basregister
      {
        label: 'Basregister',
        icon: ['fal', 'cabinet-filing'],
        to: {
          name: 'basregister',
          params: {
            type: 'Employer',
            trust: $route.params.trust
          }
        },
        children: [
          {
            label: 'Arbetsgivare',
            to: {
              name: 'basregister',
              params: {
                type: 'Employer',
                trust: $route.params.trust
              }
            }
          },
          {
            label: 'Pensionsberättigade',
            to: {
              name: 'basregister',
              params: {
                type: 'Pensionable',
                trust: $route.params.trust
              }
            }
          },
          {
            label: 'Rådgivare',
            to: {
              name: 'common-basregister',
              params: {
                type: 'Advisor',
                trust: $route.params.trust
              }
            }
          },
          {
            label: 'Kontoplan',
            to: {
              name: 'common-basregister',
              params: {
                type: 'Account',
                trust: $route.params.trust
              }
            }
          },
          {
            label: 'Utfästelser',
            to: {
              name: 'basregister',
              params: {
                type: 'Pledge',
                trust: $route.params.trust
              }
            }
          },
          {
            label: 'Transaktionstyp',
            to: {
              name: 'common-basregister',
              params: {
                type: 'TransactionType',
                trust: $route.params.trust
              }
            }
          },
          {
            label: 'Placeringar',
            to: {
              name: 'basregister',
              params: {
                type: 'Instrument',
                trust: $route.params.trust
              }
            }
          }
        ]
      },
      // Registrering
      {
        label: 'Registrering',
        icon: ['fal', 'handshake-alt'],
        to: {
          name: 'do',
          params: {
            type: 'Transaction',
            actiontype: 'deposit',
            trust: $route.params.trust,
            primaryKey: 'new'
          }
        },
        children: [
          {
            label: 'Registrering',
            to: {
              name: 'do',
              params: {
                type: 'Transaction',
                actiontype: 'deposit',
                trust: $route.params.trust,
                primaryKey: 'new'
              }
            }
          },
          {
            label: 'Värdeförändring',
            to: {
              name: 'do',
              params: {
                type: 'Transaction',
                actiontype: 'growth',
                trust: $route.params.trust,
                primaryKey: 'new'
              }
            }
          },
          {
            label: 'Avgifter',
            to: {
              name: 'do',
              params: {
                type: 'Transaction',
                actiontype: 'fee',
                trust: $route.params.trust,
                primaryKey: 'new'
              }
            }
          },
          {
            label: 'Transaktioner',
            to: {
              name: 'basregister',
              params: {
                type: 'Transaction',
                trust: $route.params.trust
              }
            }
          },
          {
            type: 'divider'
          },
          {
            label: 'Pensionsutbetalning',
            to: {
              name: 'do',
              params: {
                type: 'Payout',
                actiontype: 'salary',
                trust: $route.params.trust,
                primaryKey: 'new'
              }
            }
          },
          {
            label: 'Utbetalningar',
            to: {
              name: 'basregister',
              params: {
                type: 'Payout',
                trust: $route.params.trust
              }
            }
          },
          {
            label: 'Utbetalningsrader',
            to: {
              name: 'basregister',
              params: {
                type: 'PayoutRow',
                trust: $route.params.trust
              }
            }
          },
          {
            type: 'divider'
          },
          {
            label: 'Placeringsflytt',
            to: {
              name: 'do',
              params: {
                type: 'TransactionTransfer',
                actiontype: 'transfer',
                trust: $route.params.trust,
                primaryKey: 'new'
              }
            }
          },
          {
            label: 'Placeringsflytt Historik',
            to: {
              name: 'basregister',
              params: {
                type: 'TransactionTransfer',
                trust: $route.params.trust
              }
            }
          },
          {
            type: 'divider'
          },
          {
            label: 'Historik Registrering',
            to: {
              name: 'basregister',
              params: {
                type: 'Execution',
                trust: $route.params.trust
              }
            }
          },
          {
            label: 'Historiskt Kapital',
            to: {
              name: 'do',
              params: {
                type: 'Transaction',
                actiontype: 'history',
                trust: $route.params.trust,
                primaryKey: 'new'
              }
            }
          }
        ]
      },
      // Rapporter
      {
        label: 'Rapporter',
        icon: ['fal', 'file-chart-pie'],
        to: {
          name: 'basregister',
          params: {
            type: 'Report',
            trust: $route.params.trust
          }
        },
        children: [
          {
            label: 'Bokföringsunderlag',
            to: {
              name: 'do',
              params: {
                type: 'Report',
                actiontype: 'bookkeeping',
                trust: $route.params.trust,
                primaryKey: 'new'
              }
            }
          },
          {
            label: 'Typrapport Bokslut',
            to: {
              name: 'do',
              params: {
                type: 'Report',
                actiontype: 'typereport',
                trust: $route.params.trust,
                primaryKey: 'new'
              }
            }
          },
          {
            label: 'Destinatärsrapport',
            to: {
              name: 'do',
              params: {
                type: 'Report',
                actiontype: 'transactionspensionable',
                trust: $route.params.trust,
                primaryKey: 'new'
              }
            }
          },
          {
            label: 'Värdebesked',
            to: {
              name: 'do',
              params: {
                type: 'Report',
                actiontype: 'valuestatement',
                trust: $route.params.trust,
                primaryKey: 'new'
              }
            }
          },
          {
            label: 'Avkastningsbesked',
            to: {
              name: 'do',
              params: {
                type: 'Report',
                actiontype: 'yieldstatement',
                trust: $route.params.trust,
                primaryKey: 'new'
              }
            }
          },
          {
            label: 'Utfästelserapport',
            to: {
              name: 'do',
              params: {
                type: 'Report',
                actiontype: 'pledgestatement',
                trust: $route.params.trust,
                primaryKey: 'new'
              }
            }
          },
          {
            label: 'Totaler',
            to: {
              name: 'do',
              params: {
                type: 'Report',
                actiontype: 'totals',
                trust: $route.params.trust,
                primaryKey: 'new'
              }
            }
          },
          {
            label: 'Historik Rapporter',
            to: {
              name: 'basregister',
              params: {
                type: 'Report',
                trust: $route.params.trust
              }
            }
          }
        ]
      },
      // Inställningar
      {
        label: 'Inställningar',
        icon: ['fal', 'sliders-h-square'],
        to: {
          name: 'basregister',
          params: {
            type: 'Settings',
            trust: $route.params.trust
          }
        },
        children: [
          {
            label: 'Allmänna',
            to: {
              name: 'basregister',
              params: {
                type: 'Settings',
                trust: $route.params.trust
              }
            }
          },
          {
            label: 'Avgifter',
            to: {
              name: 'basregister',
              params: {
                type: 'Fee',
                trust: $route.params.trust
              }
            }
          },
          {
            label: 'Stiftelser',
            to: {
              name: 'common-basregister',
              params: {
                type: 'Trust',
                trust: $route.params.trust
              }
            }
          },
          {
            label: 'Revisionslogg',
            to: {
              name: 'common-basregister',
              params: {
                type: 'Auditlog',
                trust: $route.params.trust
              }
            }
          },
          {
            label: 'Prisbasbelopp',
            to: {
              name: 'common-basregister',
              params: {
                type: 'Prisbasbelopp',
                trust: $route.params.trust
              }
            }
          }
        ]
      }
      // Sök
      // {
      //   label: 'Sök',
      //   icon: ['fal', 'search'],
      //   to: {
      //     name: 'sok',
      //     params: {
      //       trust: $route.params.trust
      //     }
      //   }
      // }
    ]
  }

  get items() {
    return this.nav
  }

  getByParams(params) {
    for (const item of this.nav) {
      for (const child of item.children || []) {
        if (child.to && child.to.params) {
          let match = true
          for (const key in params) {
            if (params[key] !== child.to.params[key]) {
              match = false
              break
            }
          }
          if (match) {
            return child
          }
        }
      }
    }
    return null
  }

  breadcrumbs() {
    const crumbs = []
    const params = this.$route.params

    let item
    if (params.primaryKey) {
      crumbs.push({
        label: params.primaryKey === 'new' ? 'Ny' : params.primaryKey
      })
      item = this.getByParams(params)
      if (!item) {
        item = this.getByParams({
          ...params,
          primaryKey: undefined
        })
      }
    } else {
      item = this.getByParams(params)
    }

    if (item) {
      crumbs.push({
        label: item.label,
        url: item?.to?.params?.primaryKey ? null : item.to
      })
    }

    return crumbs.reverse()
  }
}

export default Navigation
